import { render, staticRenderFns } from "./ViaSatBol2.vue?vue&type=template&id=410b5451&scoped=true&"
import script from "./ViaSatBol2.vue?vue&type=script&lang=js&"
export * from "./ViaSatBol2.vue?vue&type=script&lang=js&"
import style0 from "./ViaSatBol2.vue?vue&type=style&index=0&id=410b5451&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410b5451",
  null
  
)

export default component.exports